import { actionTypes, BaseAction } from 'redux/actions';
import { Favorite } from 'bff/models/member';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import _ from 'lodash';

export interface MyFavoriteState {
  hasFavorite:boolean,
  myFavoriteList:Favorite[],
  fetchFavoriteComplete:boolean,
  unloginAddItem: {
    InsTypeId: string;
    PlanId: string;
    ProdId: string;
  }
};

const tempFavoriteList:any = storageService.getItem(storageKeys.MyFavorieState)
  ? JSON.parse(storageService.getItem(storageKeys.MyFavorieState)) as Favorite[]
  : null;

const initState:MyFavoriteState = {
  hasFavorite: tempFavoriteList
    ? _.filter(tempFavoriteList, (val:Favorite) => val.CONTENT).length > 0
    : false,
  myFavoriteList: tempFavoriteList && tempFavoriteList.length > 0
    ? tempFavoriteList
    : [],
  fetchFavoriteComplete: Array.isArray(tempFavoriteList),
  unloginAddItem: {
    InsTypeId: '',
    PlanId: '',
    ProdId: ''
  }
};

export const myFavoriteReducer = (state = initState, action:BaseAction) => {
  switch (action.type) {
    case actionTypes.MYFAVORITE.FETCH_MY_FAVORITE_COMPLETE:
      storageService.removeItem(storageKeys.MyFavorieState);
      storageService.setItem(storageKeys.MyFavorieState, JSON.stringify(action.payload));
      // console.log('myFavoriteList', action.payload);
      return {
        ...state,
        myFavoriteList: [...action.payload],
        hasFavorite: _.filter(action.payload, (val:Favorite) => val.CONTENT).length > 0,
        fetchFavoriteComplete: true,
        unloginAddItem: {
          InsTypeId: '',
          PlanId: '',
          ProdId: ''
        }
      };
    case actionTypes.MEMBER.LOG_OUT:
    {
      // 取出未經授權 TOKEN 的提示訊息
      const unauthorizedMsg = storageService.getItem(storageKeys.UnauthorizedMsg);
      // 清除暫存資料
      storageService.clearAll.all();
      // 重新設回未經授權 TOKEN 的提示訊息
      storageService.setItem(storageKeys.UnauthorizedMsg, unauthorizedMsg);
      return {
        ...state,
        hasFavorite: false,
        myFavoriteList: new Array(0),
        fetchFavoriteComplete: false,
        unloginAddItem: {
          InsTypeId: '',
          PlanId: '',
          ProdId: ''
        }
      };
    }
    case actionTypes.MYFAVORITE.UNLOGIN_ADD_FAVORITE_ITEM:
      return {
        ...state,
        unloginAddItem: {
          InsTypeId: action.payload.InsTypeId,
          PlanId: action.payload.PlanId,
          ProdId: action.payload.ProdId
        }
      };
    default:
      return state;
  };
};
